import moment from "jalali-moment";

export const TOTAL_SERIES_KEY = "total";
export const TOTAL_COLOR = "#17233b";
export const EARNED_COLOR = "#168a50";
export const SPENT_COLOR = "#b42318";

export const GROUP_TYPE_COLORS = {
    public: "#2e71fc",
    org: "#d97706",
    special: "#7c3aed",
};

const FALLBACK_COLORS = ["#0ea5e9", "#db2777", "#059669", "#ea580c"];

export function monthLabel(year, month, language = "fa") {
    if (!year || !month) return "";
    const locale = String(language || "fa").startsWith("en") ? "en" : "fa";
    return moment(`${year}/${month}/01`, "YYYY/M/D")
        .locale(locale)
        .format("MMMM YY");
}

export function groupSeriesKey(group) {
    if (group?.id == null) return "ungrouped";
    return `group_${group.id}`;
}

export function groupColor(group, index = 0) {
    const typeColor = GROUP_TYPE_COLORS[group?.group_type];
    if (typeColor) return typeColor;
    return FALLBACK_COLORS[index % FALLBACK_COLORS.length];
}

function collectGroups(joinedByMonth, groups) {
    const series = [];
    const seen = new Set();
    const add = (group) => {
        const key = groupSeriesKey(group);
        if (seen.has(key)) return;
        seen.add(key);
        series.push({
            key,
            id: group?.id ?? null,
            name: group?.name || "",
            group_type: group?.group_type || null,
            color: groupColor(group, series.length),
        });
    };
    (joinedByMonth || []).forEach((row) => {
        (row.groups || []).forEach(add);
    });
    (groups || []).forEach(add);
    return series;
}

export function memberTrendChartData(
    joinedByMonth,
    groups = [],
    language = "fa"
) {
    const series = collectGroups(joinedByMonth, groups);
    const data = (joinedByMonth || []).map((row) => {
        const point = {
            year: row.year,
            month: row.month,
            label: monthLabel(row.year, row.month, language),
            [TOTAL_SERIES_KEY]: Number(row.joined || 0),
        };
        const byKey = {};
        (row.groups || []).forEach((group) => {
            byKey[groupSeriesKey(group)] = Number(group.joined || 0);
        });
        series.forEach((item) => {
            point[item.key] = byKey[item.key] || 0;
        });
        return point;
    });
    return { data, series };
}

export function memberCompositionData(groups) {
    return (groups || [])
        .filter((group) => Number(group.count || 0) > 0)
        .map((group, index) => ({
            key: groupSeriesKey(group),
            id: group.id ?? null,
            name: group.name || "",
            group_type: group.group_type || null,
            value: Number(group.count || 0),
            color: groupColor(group, index),
        }));
}

export function coinsTrendChartData(coinsByMonth, language = "fa") {
    return (coinsByMonth || []).map((row) => ({
        year: row.year,
        month: row.month,
        label: monthLabel(row.year, row.month, language),
        earned: Number(row.earned || 0),
        spent: Number(row.spent || 0),
    }));
}
